import { render, staticRenderFns } from "./container.vue?vue&type=template&id=e0434d84&scoped=true&"
import script from "./container.vue?vue&type=script&lang=ts&"
export * from "./container.vue?vue&type=script&lang=ts&"
import style0 from "./container.vue?vue&type=style&index=0&id=e0434d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0434d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0434d84')) {
      api.createRecord('e0434d84', component.options)
    } else {
      api.reload('e0434d84', component.options)
    }
    module.hot.accept("./container.vue?vue&type=template&id=e0434d84&scoped=true&", function () {
      api.rerender('e0434d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/tabs/container.vue"
export default component.exports